<template>
  <div>
    <v-card>
      <v-card-title>Anulowanie rezerwacji</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              v-model="model.slotIds"
              label="Id slotow oddzielone przecinkiem, spacją lub średnikiem"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="2">
            <v-btn color="primary" @click="checkReservation"
              >Sprawdz rezerwacje</v-btn
            >
          </v-col>
        </v-row>
        <v-row v-if="checkSlotResult">
          <v-col v-if="checkSlotResult.incorrectSlots.length == 0"
            ><v-alert color="success"
              >Wszyskie rezerwacje sa mozliwe do anulowania</v-alert
            >
          </v-col>
          <v-col
            v-else-if="
              checkSlotResult.correctSlots.length != 0 &&
              checkSlotResult.incorrectSlots.length != 0
            "
          >
            <v-alert color="warning"
              >Część rezewacji nie moze zostać znaleziona, mogą być przedawnione
              lub anulowane {{ checkSlotResult.incorrectSlots }}</v-alert
            >
          </v-col>
          <v-col v-else>
            <v-alert color="error"
              >Żadna z rezerwacji nie została znaleziona, mogą być przedawnione
              lub anulowane</v-alert
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-switch label="Wyślij maila" v-model="model.sendMail"></v-switch>
          </v-col>
        </v-row>
        <v-row v-if="model.sendMail">
          <v-col>
            <v-text-field
              label="Tytuł"
              v-model="model.mailTitle"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Pole od"
              v-model="model.mailFrom"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="model.sendMail">
          <v-col>
            <ckeditor
              v-model="model.mailContent"
              :config="editorConfig"
              editorUrl="https://cdn.ckeditor.com/4.14.0/full-all/ckeditor.js"
            ></ckeditor>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions
        ><v-btn @click="cancelReservations" color="primary"
          >Anuluj rezerwacje</v-btn
        ></v-card-actions
      >
    </v-card>
  </div>
</template>

<script>
import CKEditor from "ckeditor4-vue";
import { showSuccess } from "@/helpers";
export default {
  data() {
    return {
      model: {
        mailTitle: "Anulowanie rezerwacji",
        mailContent: `<h2>Anulowanie rezerwacji</h2>

<p>Numer rezerwacji: <a href="@link">@reservationId</a></p>

<p>Wybrana operacja: @operationName</p>

<p>Wybrana godzina: @slotDateTime</p>

<p>@foreachProperty</p>

<p>{</p>

<p>@propertyName: @propertyValue</p>

<p>}</p>

<p>&nbsp;</p>

<p>&nbsp;</p>
`,
      },
      editorConfig: {
        height: 500,
      },
      checkSlotResult: null,
    };
  },
  components: {
    ckeditor: CKEditor.component,
  },
  methods: {
    async cancelReservations() {
      var model = JSON.parse(JSON.stringify(this.model));
      model.slotIds = model.slotIds
        .split(/[ ,;]/)
        .map((o) => parseInt(o.trim()));
      const { data } = await this.$http.post(
        "Slot/CancelReservationRange",
        model
      );
      if (data) {
        showSuccess("Rezerwacje zostały anulowane");
        this.model.slotIds = "";
        this.model.sendMail = false;
      }
    },
    async checkReservation() {
      this.checkSlotResult = null;
      const { data } = await this.$http.post(
        "Slot/CheckReservationToCancel",
        this.model.slotIds.split(/[ ,;]/).map((o) => parseInt(o.trim()))
      );
      this.checkSlotResult = data;
    },
  },
};
</script>
